import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import BodyText from 'LuxKit/Typography/BodyText'

const PriceSection = styled.div`
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  display: flex;
  flex-direction: column;
  padding: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.M};

  ${mediaQueryUp.tablet} {
    flex-direction: row;
  }
`

const DateWrapper = styled.div`
  flex: 1;
  text-align: center;

  & + & {
    border-top: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
    padding-top: ${rem(12)};
    margin-top: ${rem(12)};

    ${mediaQueryUp.tablet} {
      padding-top: 0;
      margin-top: 0;
      border-top: 0;
      padding-left: ${rem(12)};
      margin-left: ${rem(12)};
      border-left: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
    }
  }
`

interface Props {
  tripDates: string
  itemDates: string
  itemType: string
  className?: string
}

function DateChangeView(props: Props) {
  const {
    tripDates,
    itemDates,
    itemType,
    className,
  } = props

  const intl = useIntl()

  return (
    <PriceSection className={className}>
      <DateWrapper>
        <BodyText variant="medium" colour="normal-contrast">
          {intl.formatMessage({
            id: 'FR5W28ea3EY9ohmcrZ_5',
            defaultMessage: 'Your overall trip dates',
            description: 'Label for the overall trip date range in the date change comparison view',
          })}
        </BodyText>
        <Heading variant="heading5" colour="normal-contrast">
          {tripDates}
        </Heading>
      </DateWrapper>
      <DateWrapper>
        <BodyText variant="medium" colour="normal-contrast">
          {intl.formatMessage(
            {
              id: 'GBKLYEI3m1o1vFr4HGg_',
              defaultMessage: '{itemType} dates',
              description: 'Label for an item type date range in the date change comparison view, e.g. "Hotel dates"',
            },
            { itemType },
          )}
        </BodyText>
        <Heading variant="heading5" colour="normal-contrast">
          {itemDates}
        </Heading>
      </DateWrapper>
    </PriceSection>
  )
}

export default DateChangeView
